import { createRoleGuard } from './role-guard';

export const isPlannerGuard = createRoleGuard(user => user.isPlannerUser());
